import { PopoverProps } from "@mui/material";

export const POPOVER_BOTTOM: Pick<PopoverProps, "anchorOrigin" | "transformOrigin"> = {
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "center",
	},
	transformOrigin: {
		vertical: "top",
		horizontal: "center",
	},
};

export const POPOVER_BOTTOM_START: Pick<PopoverProps, "anchorOrigin" | "transformOrigin"> = {
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	transformOrigin: {
		vertical: "top",
		horizontal: "left",
	},
};

export const POPOVER_BOTTOM_END: Pick<PopoverProps, "anchorOrigin" | "transformOrigin"> = {
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "right",
	},
	transformOrigin: {
		vertical: "top",
		horizontal: "right",
	},
};

export const POPOVER_TOP_START: Pick<PopoverProps, "anchorOrigin" | "transformOrigin"> = {
	anchorOrigin: {
		vertical: "top",
		horizontal: "left",
	},
	transformOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
};

export const POPOVER_TOP_END: Pick<PopoverProps, "anchorOrigin" | "transformOrigin"> = {
	anchorOrigin: {
		vertical: "top",
		horizontal: "right",
	},
	transformOrigin: {
		vertical: "bottom",
		horizontal: "right",
	},
};

export const POPOVER_RIGHT_START: Pick<PopoverProps, "anchorOrigin" | "transformOrigin"> = {
	anchorOrigin: {
		vertical: "top",
		horizontal: "right",
	},
	transformOrigin: {
		vertical: "top",
		horizontal: "left",
	},
};

export const POPOVER_OVERLAP: Pick<PopoverProps, "anchorOrigin" | "transformOrigin"> = {
	anchorOrigin: {
		vertical: "top",
		horizontal: "left",
	},
	transformOrigin: {
		vertical: "top",
		horizontal: "left",
	},
};